import { LogLevels } from 'vuejs3-logger/dist/enum/log-levels';
import { ILoggerOptions } from 'vuejs3-logger/dist/interfaces/logger-options';
const isProduction = import.meta.env.NODE_ENV === 'production';
export const loggingOptions: ILoggerOptions = {
    isEnabled: true,
    logLevel: isProduction ? LogLevels.ERROR : LogLevels.DEBUG,
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};